import React, { useEffect, useRef, useState } from "react"
import {
  Card,
  CardBody,
  Col,
  Row,
  Container,
  CardTitle,
  ModalBody,
  ModalHeader,
  Modal,
  Button,
} from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { connect } from "react-redux"
import { withTranslation } from "react-i18next"
import withRouter from "../../components/Common/withRouter"
import showNotification from "../../helpers/show_notificaton"
import {AvForm} from "availity-reactstrap-validation"
import { postSubmitForm } from "../../helpers/backend_helper"
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory from 'react-bootstrap-table2-paginator';
import filterFactory, { selectFilter } from 'react-bootstrap-table2-filter';
import BackgroundImage from "../../assets/images/Background.png"
import preloader from "../../helpers/Loader"
import moment from "moment"
import { Pagination } from "../../components/Common/Pagination"
import { sortBy } from "lodash"
import exportFromJSON from "export-from-json"

const WalletHistory = props => {

const { SearchBar } = Search
    
    const [editModal, setEditModal] = useState()
    const [selectedUser, setSelectedUser] = useState()
    const [wallet, setwallet] = useState()
    const [allTransactions, setAllTransactions] = useState([])
     //for customer wallet pagination
    const [pageNumberForWallet, setPageNumberForWallet] = useState(1);
    const [pageSizeForWallet, setPageSizeForWallet] = useState(100);
    const [totalPageForWallet, setTotalPageForWallet] = useState(1)
     //for external pagination
    const [pageNumber, setPageNumber] = useState(1);
    const [pageSize, setPageSize] = useState(100);
    const [totalPage, setTotalPage] = useState(1)

    useEffect(()=>{
      loadAllTransactions(null)
      },[pageNumber])

    
    const customTotal = (from, to, size) => (
      <span className="react-bootstrap-table-pagination-total">
        Showing {from} - {to} of {size} records.
      </span>
    );
  
    const options = {
      paginationSize: 20,
      pageStartIndex: 1,
      onPageChange: (page, sizePerPage) => {
        setPageNumberForWallet(page);
        setPageSizeForWallet(sizePerPage);
      },
      firstPageText: "First",
      prePageText: "Prev",
      nextPageText: "Next",
      lastPageText: "Last",
      nextPageTitle: "First",
      prePageTitle: "Pre page",
      firstPageTitle: "Next page",
      lastPageTitle: "Last page",
      showTotal: true,
      paginationTotalRenderer: customTotal,
      disablePageTitle: true,
      sizePerPageList: [
        {
          text: "100",
          value: 100,
        },
        {
          text: "200",
          value: 200,
        },
        {
          text: "300",
          value: 300,
        },
        {
          text: "All",
          value: wallet && wallet.length,
        },
      ],
      hideSizePerPage: true,
      ignoreSinglePage: true,
    };


      const loadAllTransactions = async (e) => {
       try {
         preloader(true)
        e&&setPageNumber(1)
        let url = process.env.REACT_APP_BASEURL + "customers/getall_for_wallet"
        let response = await postSubmitForm(url, {limit: 100,page: pageNumber})
        if (response.data.status === 1) {
          // const sortedList = sortBy(response.data.customers, "name")
          preloader(false)
          setTotalPage(response.data.totalPages)
          setAllTransactions(response.data.customers)
        } else {
          preloader(false)
          showNotification(response.data.message, "Error")
        }
       } catch (error) {
        console.log(error);
       } finally {
        preloader(false)
       }
      }
 
      function editFormatter(cell, row) {
        return (
          <span className="text-info">
            <i
              className="bx bxs-file fs-5"
              title="Click to View Transactions "
              style={{ cursor: "pointer", color:"blue" }}
              onClick={() => {
                setEditModal(!editModal)
                setSelectedUser(row)
                setwallet(row.wallet_transactions)
              }}
            ></i>
          </span>
        )
      }
    
      const columns = [
        {
          dataField: "_id",
          formatter: (cell, row, rowIndex) => {
            const rowNumber = (+pageNumber - 1) * +pageSize + (+rowIndex + 1);
            return rowNumber;
          },
          text: props.t("#"),
          headerStyle: (colum, colIndex) => {
            return { width: "0.5%" }
          },
        },
        {
          text: props.t("Name"),
          //formatter: employeeFormatter,
          dataField: "name",
          sort: true,
          headerStyle: (colum, colIndex) => {
            return { width: "5%" }
          },
        },
        {
          text: props.t("Mobile"),
          //formatter: employeeFormatter,
          dataField: "mobile",
          sort: true,
          headerStyle: (colum, colIndex) => {
            return { width: "5%" }
          },
        },
        {
            text: props.t("Wallet Balance"),
            dataField: "wallet",
            sort: true,
            headerStyle: (colum, colIndex) => {
              return { width: "5%" }
            },
          },
          {
            text: props.t("Type"),
            //formatter: employeeFormatter,
            dataField: "customer_type",
            filter: selectFilter({
              options: [
                { value: "Regular", label: "Regular" },
                { value: "VIP", label: "VIP" },
                { value: "Friend", label: "Friend" },
              ],
              placeholder: "ALL",
              style: {
                height: "30px",
                padding: "6px 12px",
                width: "100px",
                margin: "0 10px",
                borderRadius: "4px",
                // fontSize: "15px",
              }
            }),
            headerStyle: (colum, colIndex) => {
              return { width: "2%" }
            },
          },
         {
          dataField: "customerCreatedBy.employee_name",
          text: props.t("Customer Created Info"), 
          sort: true,
          formatter: (cell, row) => {
            const createdBy = row.customerCreatedBy?.employee_name || "-";
            const createdOn = row.createdAt
              ? moment(row.createdAt).format("YYYY-MM-DD HH:mm")
              : "-";

            return (
              <div style={{ display: "flex", flexDirection: "column", lineHeight: "1.4" }}>
                <span><strong>{props.t("By")}:</strong> {createdBy}</span>
                <span><strong>{props.t("On")}:</strong> {createdOn}</span>
              </div>
            );
          },
          headerStyle: () => {
            return { width: "10%" }; 
          },
        },
        {
          dataField: "",
          text: props.t("Action"),
          formatter: editFormatter,
          sort: false,
          headerStyle: (colum, colIndex) => {
            return { width: "1%" }
          },
        },
      ]

      const walletColumn = [
        {
          dataField: "_id",
          formatter: (cell, row, rowIndex) => {
            const rowNumber = (+pageNumberForWallet - 1) * +pageSizeForWallet + (+rowIndex + 1);
            return rowNumber;
          },
          text: props.t("#"),
          headerStyle: (colum, colIndex) => {
            return { width: "0.5%" }
          },
        },
        {
          text: props.t("Amount"),
          //formatter: employeeFormatter,
          dataField: "transaction_amount",
          sort: true,
          headerStyle: (colum, colIndex) => {
            return { width: "5%" }
          },
        },
        {
          text: props.t("Transaction Date"),
          //formatter: employeeFormatter,
          dataField: "transaction_date",
          sort: true,
          formatter:(cell,row)=>{
            return moment(row.transaction_date).format('YYYY-MM-DD HH:mm')
          },
          headerStyle: (colum, colIndex) => {
            return { width: "5%" }
          },
        },
        {
            text: props.t("Transaction Remarks"),
            dataField: "transaction_remarks",
            sort: true,
            headerStyle: (colum, colIndex) => {
              return { width: "5%" }
            },
          },
          {
            text: props.t("Transaction Type"),
            //formatter: employeeFormatter,
            dataField: "transaction_type",
            sort: true,
            headerStyle: (colum, colIndex) => {
              return { width: "5%" }
            },
          },
      ]
       const defaultSorted = [{
    dataField: 'transaction_date',
    order: 'desc'
  }];

      const handleDownload = async () => {
          const fileName = "Wallet History";
          const exportType = "xls";
      
          // let data_to_export = allCustomer;
          let data_to_export = allTransactions
      
          if (data_to_export) {
            var data = [];
            JSON.parse(JSON.stringify(data_to_export)).forEach(function (v) {
              data.push({
                Name: v.name,
                Mobile: v.mobile,
                Email: v.email,
                Wallet_Balance: v.wallet,
                Customer_Type: v.customer_type,
                Created_On: moment(v.createdAt).format("YYYY-MM-DD HH:mm"),
                Created_by: v.customerCreatedBy?.employee_name,
              });
            });
            exportFromJSON({ data, fileName, exportType });
          }
        }

      const backgroundImageStyle = {
        backgroundImage: `url(${BackgroundImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
    
        
      };
    
  return (
    <React.Fragment>
      <div className="page-content" style={backgroundImageStyle}>
        <Container fluid={true}>
          <Breadcrumbs title={props.t("Customer")} 
            breadcrumbItem1={props.t("Wallet History")}
            alternateTitle={props.t("Wallet History")}
            />

          <Row>
            <Col lg={12}>
              <Card>
             
                <CardBody
                style={{
                  boxShadow:
                    "rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
                }}
                >
                <CardTitle>
                    <Row>
                      <Col lg={6}>
                      {props.t("All Transactions")}
                      </Col>
<Col lg={6} style={{ display: "flex", justifyContent: "flex-end" }}>
                        <Button
                          style={{ width: "115px", height: "35px", background: "#F93A5C", border: "none" }}

                          type="submit"
                          className="btn btn-sm btn-secondary"
                          onClick={handleDownload}
                          disabled={!allTransactions}
                        >
                          <i className="mdi mdi-file-export" /> &nbsp;
                          {props.t("Export CSV")}
                        </Button>
                      </Col>
                    </Row>
                  </CardTitle>
                  <ToolkitProvider
                    keyField="_id"
                    columns={columns}
                    data={allTransactions && allTransactions || []}
                    search
                  >
                    {propst => (
                      <div>
                        <AvForm>
                          <Row>
                            <Col lg={4} style={{display:"flex", alignItems:"flex-start"}}>
                              <SearchBar
                                {...propst.searchProps}
                                style={{ width: "340px" }}
                              />
                            </Col>
                          </Row>
                        </AvForm>
                        <BootstrapTable
                          {...propst.baseProps}
                          noDataIndication={props.t("No data to display.")}
                          striped
                          hover
                          filter={filterFactory()}
                          condensed
                          // pagination={paginationFactory(options)}
                        />
                    <Pagination pageNumber={pageNumber} setPageNumber={setPageNumber} totalPage={totalPage}/>
                      </div>
                    )}
                  </ToolkitProvider>
               
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>

        {/* view modal */}

        <Modal
                    size="lg"
                    isOpen={editModal}
                    toggle={() => setEditModal(!editModal)}
                  >
                    <ModalHeader toggle={() => setEditModal(!editModal)}>
                      {props.t("Transaction History - ")}
                      {selectedUser && selectedUser.name}
                    </ModalHeader>
                    <ModalBody>
                    <ToolkitProvider
                    keyField="_id"
                    columns={walletColumn}
                    data={wallet && wallet || []}
                    search
                  >
                    {propst => (
                      <div>
                        <AvForm>
                          <Row>
                            <Col lg={4} style={{display:"flex", alignItems:"flex-start"}}>
                              <SearchBar
                                {...propst.searchProps}
                                style={{ width: "340px" }}
                              />
                            </Col>
                          </Row>
                        </AvForm>
                        <BootstrapTable
                          {...propst.baseProps}
                          noDataIndication={props.t("No data to display.")}
                          striped
                          hover
                          defaultSorted={ defaultSorted } 
                          condensed
                          pagination={paginationFactory(options)}
                        />
                      </div>
                    )}
                  </ToolkitProvider>
                    </ModalBody>
                  </Modal>
      </div>
    </React.Fragment>
  )
}

export default withRouter(connect(null, {})(withTranslation()(WalletHistory)))
